<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordoglo/svgGlo33bg.svg" />

    <p class="textBase appearAnimationB" id="text01">
      el saco vocal amplía    </p>

    <p class="textBase hover-animation-c appearAnimationA" id="tag01">
      mucho el volumen del sonido.
    </p>

    <p class="textBase appearAnimationB" id="text02">ES LO MISMO QUE DECIR</p>

    <label class="toggleButtonContainer pageElement" id="toggle01"
      >el saco vocal sirve para que el sonido sea muy fuerte.
      <input type="radio" name="sapos" />
      <span class="toggleButton"></span>
    </label>
    <label class="toggleButtonContainer pageElement" id="toggle02"
      >el saco vocal sirve para que el sonido apenas se escuche.
      <input type="radio" name="sapos" />
      <span class="toggleButton"></span>
    </label>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: -1px;
  top: 407px;
}

#text01 {
  position: absolute;
  width: 730px;
  height: 50px;
  left: 75px;
  top: 80px;
  font-style: italic;
  font-weight: normal;
  font-size: 29px;
  line-height: 45px;
  color: #000000;
  text-transform: uppercase;
}
#tag01 {
  position: absolute;
  width: 515px;
  height: 50px;
  left: 416px;
  top: 75px;
  text-align: center;
  background-color: #00a5a5;
  font-style: italic;
  font-weight: normal;
  font-size: 29px;
  line-height: 45px;
  color: #ffffff;
  text-transform: uppercase;
}
#text02 {
  position: absolute;
  left: 70px;
  top: 167px;
  font-size: 30px;
  line-height: 41px;
  color: #00a5a5;
}

label {
  font-style: italic;
  text-transform: uppercase;
  font-size: 29px;
}
#toggle01 {
  position: absolute;
  left: 65px;
  top: 238px;
}
#toggle02 {
  position: absolute;
  left: 65px;
  top: 329px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["glo/Video 144b.mp4"],
    };
  },
};
</script>